import { Component, ErrorInfo, PropsWithChildren } from "react";

import { type WidgetKey } from "config/features";
import { telemetry } from "telemetry";

import { WidgetError } from "./widgetError";

export class WidgetErrorBoundary extends Component<PropsWithChildren<{ widgetKey: WidgetKey }>, { hasError: boolean }> {
    constructor(props: { widgetKey: WidgetKey }) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.warn(error, errorInfo);

        telemetry.trackEvent(
            "unhandled_error",
            {
                "widget.key": this.props.widgetKey,
                "error.source": "widget_error_boundary",
                "error.component_stack": errorInfo.componentStack ?? "",
            },
            error,
        );
    }

    render() {
        if (this.state.hasError) {
            return <WidgetError widgetKey={this.props.widgetKey} />;
        }

        return this.props.children;
    }
}
